import React, { useEffect } from "react";
  
 
const AdminProduct = (props) => {
    
 return (
    <div>
      <hr />
      
      <figure className="figure p-4 m-5">
           
         <h1>   Admin Product page   </h1>  
         
      </figure>
    </div> 
  );
};
export default AdminProduct;
